// @ts-ignore
import NurofenRg from '../../../../static/fonts/NurofenText_W_Rg.woff';
// @ts-ignore
import NurofenBd from '../../../../static/fonts/NurofenText_W_Bd.woff';

const Fonts = [NurofenRg, NurofenBd];

export default Fonts;
